// ─────────────────────────────────────────────────────────────
// KONTAK BİLGİLERİ — yalnızca bu bloğu güncelle.
// Runtime'da değerler /api/public/settings (admin paneli) üzerinden gelir.
// Burası sadece backend cevap vermeden önce gösterilen fallback'tir.
// ─────────────────────────────────────────────────────────────
const _whatsappNumber = "905551234567"; // sadece rakam, boşluksuz

export const siteConfig = {
  brand: "DEKOSTA3D",
  logoText: "DEKOSTA3D",
  logoImageUrl: "",
  tagline: "Türkiye'nin Hızlı 3D Baskı Platformu",
  whatsappNumber: _whatsappNumber,
  whatsappDisplay: "+90 555 123 45 67",
  phone: "+90 555 123 45 67",
  email: "info@dekosta3d.com",
  address: "",
  workingHours: "Pzt - Cmt • 09:00 - 19:00",
  whatsappLink: (msg = "Merhaba, 3D baskı hizmetleri hakkında bilgi almak istiyorum.") =>
    `https://wa.me/${_whatsappNumber}?text=${encodeURIComponent(msg)}`,
};

/**
 * Merge live settings (from `/api/public/settings`) over static defaults.
 * Returns an object with the same shape as siteConfig plus the full settings.
 */
export function resolveSite(live) {
  const s = live || {};
  const waNumber = s.whatsapp_number || siteConfig.whatsappNumber;
  return {
    ...siteConfig,
    brand: s.brand || siteConfig.brand,
    logoText: s.logo_text || s.brand || siteConfig.logoText,
    logoImageUrl: s.logo_image_url || siteConfig.logoImageUrl,
    tagline: s.tagline || siteConfig.tagline,
    phone: s.phone || siteConfig.phone,
    email: s.email || siteConfig.email,
    address: s.address ?? siteConfig.address,
    workingHours: s.working_hours || siteConfig.workingHours,
    whatsappNumber: waNumber,
    whatsappDisplay: s.whatsapp_display || siteConfig.whatsappDisplay,
    whatsappLink: (msg = "Merhaba, 3D baskı hizmetleri hakkında bilgi almak istiyorum.") =>
      `https://wa.me/${waNumber}?text=${encodeURIComponent(msg)}`,
    settings: s,
  };
}

export const materials = [
  { key: "PLA", name: "PLA", desc: "Kolay baskı, görsel prototipler, maketler.", spec: "Biyobozunur • 60°C ısı" },
  { key: "PETG", name: "PETG", desc: "Darbeye dayanıklı, dış mekan, fonksiyonel parçalar.", spec: "Kimyasal dayanım • 80°C" },
  { key: "ABS", name: "ABS", desc: "Isıya ve darbeye dayanıklı, otomotiv, endüstriyel.", spec: "105°C ısı • Mekanik" },
  { key: "RESIN", name: "Reçine (SLA)", desc: "Yüksek çözünürlük, takı, mikro detay, diş.", spec: "25 mikron • Hassas" },
  { key: "NYLON", name: "Nylon (PA12)", desc: "Endüstriyel fonksiyonel, kayar yüzey.", spec: "SLS kalite • Yüksek mukavemet" },
  { key: "TPU", name: "TPU", desc: "Esnek parçalar, contalar, kauçuk benzeri.", spec: "Esneklik 95A" },
];

export const services = [
  { key: "fdm", title: "FDM 3D Baskı", desc: "Hızlı, ekonomik ve güvenilir. Prototip ve son kullanım parçaları.", icon: "Layers" },
  { key: "resin", title: "Reçine Baskı (SLA/DLP)", desc: "Mikron seviye detay. Takı, dental ve görsel modeller.", icon: "Droplets" },
  { key: "prototype", title: "Hızlı Prototipleme", desc: "Fikirden fiziksel parçaya 48 saatte.", icon: "Zap" },
  { key: "functional", title: "Fonksiyonel Parçalar", desc: "Mühendislik malzemeleri ile dayanıklı parçalar.", icon: "Settings" },
  { key: "architecture", title: "Mimari Maket", desc: "Mimari ve kentsel modeller, yüksek doğrulukla.", icon: "Building2" },
  { key: "batch", title: "Küçük Seri Üretim", desc: "10–1000 adet arası seri üretim çözümleri.", icon: "Boxes" },
];

export const faqs = [
  {
    q: "Teklifi ne kadar sürede alabilirim?",
    a: "Dosyanızı yükledikten sonra mühendis ekibimiz genellikle 1–2 saat içerisinde net bir fiyat ve termin bilgisiyle dönüş yapar.",
  },
  {
    q: "Hangi dosya formatlarını destekliyorsunuz?",
    a: "STL, OBJ ve STEP (STP) formatlarını kabul ediyoruz. Çok parçalı montajlar için tek bir ZIP içinde de gönderebilirsiniz.",
  },
  {
    q: "Minimum sipariş adedi var mı?",
    a: "Hayır. 1 adetlik prototiplerden 1.000+ adetlik seri üretime kadar esnek çalışıyoruz.",
  },
  {
    q: "Türkiye geneli teslimat yapıyor musunuz?",
    a: "Evet. 81 il teslimatı anlaşmalı kargo ağımız ile 24–72 saat içinde gerçekleşir. İstanbul içi aynı gün kurye opsiyonu mevcut.",
  },
  {
    q: "Tasarımım yok, sadece bir fikrim var. Yardımcı oluyor musunuz?",
    a: "Kesinlikle. CAD tasarım ve mühendislik danışmanlığı ekibimiz fikrinizi üretilebilir bir modele dönüştürür.",
  },
  {
    q: "Gizlilik nasıl korunuyor?",
    a: "Tüm dosyalarınız ve projeleriniz NDA kapsamında koruma altındadır. Talep üzerine imzalı NDA paylaşıyoruz.",
  },
];

export const portfolioItems = [
  {
    title: "Robotik Kol Dişli Seti",
    category: "Fonksiyonel Parça",
    image: "https://images.pexels.com/photos/9242925/pexels-photo-9242925.jpeg",
  },
  {
    title: "Hassas Reçine Prototipi",
    category: "SLA / DLP",
    image: "https://images.pexels.com/photos/12268465/pexels-photo-12268465.jpeg",
  },
  {
    title: "Mimari Konsept Maketi",
    category: "Mimari",
    image: "https://images.unsplash.com/photo-1680079526971-92914190f440",
  },
  {
    title: "Endüstriyel FDM Parça",
    category: "FDM / PETG",
    image: "https://images.unsplash.com/photo-1603974739172-4ad6a3117e40",
  },
  {
    title: "Ürün Tasarımı Prototip",
    category: "Ürün Geliştirme",
    image: "https://images.pexels.com/photos/12698667/pexels-photo-12698667.jpeg",
  },
  {
    title: "Montaj Fikstürü",
    category: "Mühendislik",
    image: "https://images.pexels.com/photos/26645377/pexels-photo-26645377.jpeg",
  },
];
